export const msalConfig = {
  auth: {
    clientId: "991e85c5-3e0c-4a05-9a06-c6abe2e46a11",
    authority: "https://login.microsoftonline.com/c0807f6d-1970-4774-af4b-ccd5740e312b",
    redirectUri: window.location.origin + "/admin",

  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["api://991e85c5-3e0c-4a05-9a06-c6abe2e46a11/access_as_user"],
};


